<template>
 <page :title="title">
   <div>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-icon>mdi-plus</v-icon>
              <v-toolbar-title>Release Claims Payment Details</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <message :messages="messages"></message>
              <form>
                 <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ labels.branch }}</v-subheader>
                      <span class="queryValue">{{ claimPayHeader.branchDesc }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <cal-picker v-model="claimPayHeader.tranDate" v-validate="'required|tranDate_today|tranDate_rangeType:' + this.parseISO(this.tranDateRange.effDate) +','+ this.parseISO(this.tranDateRange.expDate)"
                            :min="this.parseISO(this.tranDateRange.effDate)" :max="this.parseISO(this.tranDateRange.expDate)" :label="labels.tranDate"
                            :data-vv-as="labels.tranDate" data-vv-name="tranDate" :error-messages="errors.collect('tranDate')"/>
                    </v-flex>
                    <v-flex md4 xs12></v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ labels.department }}</v-subheader>
                      <span class="queryValue">{{ claimPayHeader.departmentDesc }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                     <span class="queryValue">
                          <v-checkbox v-model="claimPayHeader.clmClsd" :label="labels.clmClsd" readonly ></v-checkbox>
                        </span>
                    </v-flex>
                    <v-flex md4 xs12>
                       <v-subheader class="queryLabel">{{ labels.cseStat }}</v-subheader>
                      <span class="queryValue">{{ claimPayHeader.cseStatDesc }}</span>
                    </v-flex>
                     <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ labels.tranType1 }}</v-subheader>
                      <span class="queryValue">{{ claimPayHeader.tranType1Desc }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ labels.docNo + ' / ' + labels.fund }}</v-subheader>
                      <span class="queryValue">{{ claimPayHeader.docNo + ' / ' + claimPayHeader.fundDesc }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ labels.payeeAcctNo }}</v-subheader>
                      <span class="queryValue">{{ claimPayHeader.payeeAcctNo }}</span>
                    </v-flex>
                    <v-flex md12 xs12></v-flex>
                     <v-flex md6 xs12>
                      <v-subheader class="queryLabel">{{ labels.titleName }} / {{ labels.name }}</v-subheader>
                      <span class="queryValue">{{ claimPayHeader.titleName }} {{ claimPayHeader.name }}</span>
                    </v-flex>
                    <v-flex md6 xs12></v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ labels.addr1 }}</v-subheader>
                      <span class="queryValue">{{ claimPayHeader.addr1 }}</span>
                    </v-flex>
                      <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ labels.addr2 }}</v-subheader>
                      <span class="queryValue">{{ claimPayHeader.addr2 }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ labels.addr3 }}</v-subheader>
                      <span class="queryValue">{{ claimPayHeader.addr3 }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ labels.addr4 }}</v-subheader>
                      <span class="queryValue">{{ claimPayHeader.addr4 }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ labels.postCode }}</v-subheader>
                      <span class="queryValue">{{ claimPayHeader.postCode }}</span>
                    </v-flex>
                    <v-flex md4 xs12></v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ labels.stmtRef }}</v-subheader>
                      <span class="queryValue">{{ claimPayHeader.stmtRef }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ labels.inOutGst }}</v-subheader>
                      <span class="queryValue">{{ claimPayHeader.inOutGstDesc }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-checkbox v-model="claimPayHeader.deemGst" :label="labels.deemGst" readonly ></v-checkbox>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ labels.curr }}</v-subheader>
                      <span class="queryValue">{{ claimPayHeader.currDesc }}</span>
                    </v-flex>
                     <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ labels.exRate }}</v-subheader>
                      <span class="queryValue">{{ formatDisplayNumber(claimPayHeader.exRate,7) }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                       <v-autocomplete
                          :items="currList" item-text="label" item-value="value" v-validate="riRcvyCurrValidation"
                          v-model="claimPayHeader.riRcvyCurr" :label="labels.riRcvyCurr"  :error-messages="errors.collect('claimPayHeader.riRcvyCurr')"
                          data-vv-name="claimPayHeader.riRcvyCurr" :data-vv-as="labels.riRcvyCurr" clearable>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ labels.gstAmt }}</v-subheader>
                      <span class="queryValue">{{ formatDisplayNumber(claimPayHeader.gstAmt,2) }}</span>
                    </v-flex>
                     <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ labels.gstAmtLoc }}</v-subheader>
                      <span class="queryValue">{{ formatDisplayNumber(claimPayHeader.gstAmtLoc,2) }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ labels.prtClmPv }}</v-subheader>
                      <span class="queryValue">{{ claimPayHeader.prtClmPvDesc }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ labels.paytAmt }}</v-subheader>
                      <span class="queryValue">{{ formatDisplayNumber(claimPayHeader.paytAmt,2) }}</span>
                    </v-flex>
                     <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ labels.paytAmtLoc }}</v-subheader>
                      <span class="queryValue">{{ formatDisplayNumber(claimPayHeader.paytAmtLoc,2) }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <span class="queryValue">
                      <v-checkbox v-model="claimPayHeader.prtCseLoss" :label="labels.prtCseLoss" readonly ></v-checkbox>
                      <v-checkbox v-model="claimPayHeader.prtClmtName" :label="labels.prtClmtName" readonly></v-checkbox>
                      <v-checkbox v-model="claimPayHeader.prtLossDesc" :label="labels.prtLossDesc" readonly></v-checkbox>
                       </span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-autocomplete
                          :items="bankList" item-text="label" item-value="value" v-validate="tranTypeValidation" clearable
                          v-model="claimPayHeader.bankNo" :label="labels.bankNo"  :error-messages="errors.collect('claimPayHeader.bankNo')"
                          data-vv-name="claimPayHeader.bankNo" :data-vv-as="labels.bankNo" :disabled="!tranTypeSuffix" >
                      </v-autocomplete>
                    </v-flex>
                     <v-flex md4 xs12>
                      <v-text-field :label="labels.cheque" v-model="claimPayHeader.cheque" v-validate="chequeValidation"
                          :error-messages="errors.collect('claimPayHeader.cheque')"
                          data-vv-name="claimPayHeader.cheque" :data-vv-as="labels.cheque" :disabled="!tranTypeSuffix">
                        </v-text-field>
                    </v-flex>
                    <v-flex md4 xs12></v-flex>
                    <v-flex md4 xs12>
                      <v-autocomplete
                          :items="currList" item-text="label" item-value="value" @blur="bankCurrChange"
                          v-model="claimPayHeader.bankAcctCurr" :label="labels.bankAcctCurr"  :error-messages="errors.collect('claimPayHeader.bankAcctCurr')"
                          data-vv-name="claimPayHeader.bankAcctCurr" :data-vv-as="labels.bankAcctCurr" :disabled="true" clearable>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-text-field :label="labels.bankChrg" v-model="claimPayHeader.bankChrg"
                      :error-messages="errors.collect('bankChrg')" v-validate="bankChrgValidation" type="number"
                      data-vv-name="bankChrg" :data-vv-as="labels.bankChrg" :disabled="!tranTypeSuffix"></v-text-field>
                    </v-flex>
                     <v-flex md4 xs12>
                      <v-text-field readonly :label="labels.bankChrgLoc" v-model="claimPayHeader.bankChrgLoc"
                       :error-messages="errors.collect('bankChrgLoc')"
                      data-vv-name="bankChrgLoc" :data-vv-as="labels.bankChrgLoc" :disabled="!tranTypeSuffix" ></v-text-field>
                    </v-flex>
                  </v-layout>
                 </v-flex>
              </form>
            </v-card-text>
             <v-flex xs12 row warp>
                <v-btn color="error" dark class="mb-2"  @click.prevent="doCancel" :loading="submitting">{{labels.cancel}}<v-icon dark right>mdi-cancel</v-icon></v-btn>
                <v-btn color="primary"  @click.prevent="doSave" :loading="submitting">{{labels.save}}<v-icon right>mdi-content-save</v-icon>
                </v-btn>
             </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    </div>
  </page>
</template>
<script>

import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { parseISO } from 'date-fns'
import { formatDisplayNumber } from '@/utils/number'
import claimReleaseMixin from '@/mixins/claim/claimReleaseMixin'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import isBefore from 'date-fns/isBefore' // isBefore
import isEqual from 'date-fns/isEqual' // isEqual
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      breadcrumb: [],
      title: 'Release Claims Transaction',
      loading: true,
      currList: [],
      bankList: [],
      currRateList: [],
      disableCheqNo: true,
      tranDateRange: {},
      showTransDate: false,
      claimPayHeaderOrig: {},
      baseCurrency: undefined,
      submitting: false,
      prevRcvyCurr: '',
      claimPayHeader: {
        fundDesc: undefined,
        branchDesc: undefined,
        cseStatDesc: undefined,
        tranType1Desc: undefined,
        inOutGstDesc: undefined,
        currDesc: undefined,
        prtClmPvDesc: undefined,
        departmentDesc: undefined,
        branch: undefined,
        fund: undefined,
        tranType1: undefined,
        docNo: undefined,
        dept: undefined,
        tranDate: undefined,
        payeeAcctNo: undefined,
        titleName: undefined,
        name: undefined,
        addr1: undefined,
        addr2: undefined,
        addr3: undefined,
        addr4: undefined,
        postCode: undefined,
        stmtRef: undefined,
        curr: undefined,
        exRate: undefined,
        paytAmt: undefined,
        paytAmtLoc: undefined,
        gstRegNo: undefined,
        inOutGst: undefined,
        deemGst: undefined,
        gstStat: undefined,
        gstAmt: undefined,
        gstAmtLoc: undefined,
        netAmt: undefined,
        netAmtLoc: undefined,
        bankAcctCurr: undefined,
        bankChrg: undefined,
        bankChrgLoc: undefined,
        riRcvyCurr: undefined,
        prtCseLoss: undefined,
        prtClmtName: undefined,
        prtLossDesc: undefined,
        prtClmPv: undefined,
        tranRel: undefined,
        clmClsd: undefined,
        cseStat: undefined,
        bankNo: undefined,
        acctNoSfx: undefined,
        cheque: undefined,
        taxInv: undefined,
        bankCurrAmt: undefined,
        payBank: undefined,
        payChqNo: undefined,
        drawerName: undefined,
        cashBkNo: undefined,
        payInSlipNo: undefined,
        bankTotLocAe: undefined,
        bankTotLoc: undefined,
        acctMth: undefined,
        acctYr: undefined,
        payInsd: undefined,
        docPrtd: undefined,
        paytAmtTax: undefined,
        paytAmtTaxLoc: undefined,
        addr5: undefined,
        addr6: undefined,
        name2: undefined,
        docNoAe: undefined
      },
      labels: {
        save: 'Save and Post',
        cancel: 'Cancel',
        clmtName: 'Claimant Name',
        clmItem: 'Claim Item',
        clmClsd: 'Close Claim',
        branch: 'Branch',
        cseStat: 'Cause of Status',
        tranType1: 'Transaction Type',
        docNo: 'Document No.',
        fund: 'Fund',
        payChqNo: 'Cheque or GIRO',
        tranDate: 'Transaction Date',
        acctNoSfx: 'Suffix',
        inOutGst: 'GST I/O',
        deemGst: 'Deemed GST',
        curr: 'Payment Currency',
        exRate: 'Rate',
        riRcvyCurr: 'RI Recovery Currency',
        prtClmPv: 'Print Document',
        prtCseLoss: 'Print Cause of Loss',
        titleName: 'Title',
        prtClmtName: 'Print Claimant Name',
        name: 'Name',
        name2: 'Name2',
        prtLossDesc: 'Print Description of Loss',
        prtOffSettLtr: 'Print Offer Settlement Letter',
        addr1: 'Block/House No.',
        addr2: 'Street Name',
        addr3: 'Unit No.',
        addr4: 'Building Name',
        postCode: 'Postal Code',
        stmtRef: 'Statement Reference',
        bankNo: 'Bank No.',
        cheque: 'Cheque No.',
        bankAcctCurr: 'Bank Account Currency',
        settCode: 'Settlement Code',
        clmResCat: 'Reserve Category',
        rcvrPi: 'Recovery from P&I',
        payeeAcctNo: 'Pay Account No.',
        clmPaytType: 'Payment Type',
        isSuppGstreg: 'Is Supplier GST Registered ?',
        theirTaxInv: 'Their Tax Invoice No.',
        dvInvDate: 'DV/Invoice Date',
        paytAmt: 'Total Payment',
        paytAmtLoc: 'Local Total Payment',
        paytAmtTax: 'Amount Taxable',
        paytAmtTaxLoc: 'Local Amount Taxable',
        gstStat: 'GST Status',
        gstRate: 'GST Rate',
        gstAmt: 'Total GST Amount',
        gstAmtLoc: 'Local GST Amount',
        netAmt: 'Net Amount',
        netAmtLoc: 'Local Net Amount',
        prtCclist: 'Print Carbon Copy',
        bankChrg: 'Bank Charges',
        bankChrgLoc: '',
        paytAmtRes: 'Total Amount (in Reserve Currency)',
        prtClmDv: 'Print Discharge Voucher',
        totAmt: 'Total Amount',
        totAmtLoc: 'Local Total Amount',
        totAmtTax: 'Total Taxable Amount',
        totAmtTaxLoc: 'Local Total Taxable Amount',
        bankChrgRes: 'Bank Charges (in Reserve Currency)',
        bankDesc: 'Bank Balance',
        department: 'Department',
        address: 'Address'
      },
      param: {
        transactionType: undefined,
        bankTotalLocalCurr: undefined,
        bankTotalLocalCurrRate: undefined
      }
    }
  },
  methods: {
    async doFetch() {
      this.loading = true
      const apiUrl = this.menu.getClaimReleasePayDetailData
      if (apiUrl) {
        const expand = {
          branch: this.selected.branch,
          fund: this.selected.fund,
          tranType1: this.selected.tranType1,
          docNo: this.selected.docNo
        }
        const result = await this.$http.get(expandURI(apiUrl, expand))
        if (result && result.data) {
          const { dataMap } = result.data
          const clmPaytHdr = dataMap.clmPaytHdr
          this.claimPayHeader.branch = clmPaytHdr.branch
          this.claimPayHeader.fund = clmPaytHdr.fund
          this.claimPayHeader.tranType1 = clmPaytHdr.tranType1
          this.claimPayHeader.tranDate = new Date(clmPaytHdr.tranDate)
          this.claimPayHeader.docNo = clmPaytHdr.docNo
          this.claimPayHeader.dept = clmPaytHdr.dept
          this.claimPayHeader.payeeAcctNo = clmPaytHdr.payeeAcctNo
          this.claimPayHeader.titleName = clmPaytHdr.titleName
          this.claimPayHeader.name = clmPaytHdr.name
          this.claimPayHeader.addr1 = clmPaytHdr.addr1
          this.claimPayHeader.addr2 = clmPaytHdr.addr2
          this.claimPayHeader.addr3 = clmPaytHdr.addr3
          this.claimPayHeader.addr4 = clmPaytHdr.addr4
          this.claimPayHeader.postCode = clmPaytHdr.postCode
          this.claimPayHeader.stmtRef = clmPaytHdr.stmtRef
          this.claimPayHeader.curr = clmPaytHdr.curr
          this.claimPayHeader.exRate = clmPaytHdr.exRate
          this.claimPayHeader.paytAmt = clmPaytHdr.paytAmt
          this.claimPayHeader.paytAmtLoc = clmPaytHdr.paytAmtLoc
          this.claimPayHeader.gstRegNo = clmPaytHdr.gstRegNo
          this.claimPayHeader.inOutGst = clmPaytHdr.inOutGst
          this.claimPayHeader.deemGst = clmPaytHdr.deemGst
          this.claimPayHeader.gstStat = clmPaytHdr.gstStat
          this.claimPayHeader.gstAmt = clmPaytHdr.gstAmt
          this.claimPayHeader.gstAmtLoc = clmPaytHdr.gstAmtLoc
          this.claimPayHeader.netAmt = clmPaytHdr.netAmt
          this.claimPayHeader.netAmtLoc = clmPaytHdr.netAmtLoc
          this.claimPayHeader.bankAcctCurr = clmPaytHdr.bankAcctCurr
          this.claimPayHeader.bankChrg = clmPaytHdr.bankChrg
          this.claimPayHeader.bankChrgLoc = clmPaytHdr.bankChrgLoc
          this.claimPayHeader.riRcvyCurr = clmPaytHdr.riRcvyCurr
          this.claimPayHeader.prtCseLoss = clmPaytHdr.prtCseLoss
          this.claimPayHeader.prtClmtName = clmPaytHdr.prtClmtName
          this.claimPayHeader.prtClmPv = clmPaytHdr.prtClmPv
          this.claimPayHeader.tranRel = clmPaytHdr.tranRel
          this.claimPayHeader.clmClsd = clmPaytHdr.clmClsd
          this.claimPayHeader.cseStat = clmPaytHdr.cseStat
          this.claimPayHeader.bankNo = clmPaytHdr.bankNo
          this.claimPayHeader.acctNoSfx = clmPaytHdr.acctNoSfx
          this.claimPayHeader.cheque = clmPaytHdr.cheque
          this.claimPayHeader.taxInv = clmPaytHdr.taxInv
          this.claimPayHeader.bankCurrAmt = clmPaytHdr.bankCurrAmt
          this.claimPayHeader.payBank = clmPaytHdr.payBank
          this.claimPayHeader.payChqNo = clmPaytHdr.payChqNo
          this.claimPayHeader.drawerName = clmPaytHdr.drawerName
          this.claimPayHeader.cashBkNo = clmPaytHdr.cashBkNo
          this.claimPayHeader.payInSlipNo = clmPaytHdr.payInSlipNo
          this.claimPayHeader.bankTotLocAe = clmPaytHdr.bankTotLocAe
          this.claimPayHeader.bankTotLoc = clmPaytHdr.bankTotLoc
          this.claimPayHeader.acctMth = clmPaytHdr.acctMth
          this.claimPayHeader.acctYr = clmPaytHdr.acctYr
          this.claimPayHeader.payInsd = clmPaytHdr.payInsd
          this.claimPayHeader.docPrtd = clmPaytHdr.docPrtd
          this.claimPayHeader.paytAmtTax = clmPaytHdr.paytAmtTax
          this.claimPayHeader.paytAmtTaxLoc = clmPaytHdr.paytAmtTaxLoc
          this.claimPayHeader.addr5 = clmPaytHdr.addr5
          this.claimPayHeader.addr6 = clmPaytHdr.addr6
          this.claimPayHeader.name2 = clmPaytHdr.name2
          this.claimPayHeader.docNoAe = clmPaytHdr.docNoAe
          this.claimPayHeader.prtLossDesc = clmPaytHdr.prtLossDesc
          this.claimPayHeader.branchDesc = clmPaytHdr.branchDesc
          this.claimPayHeader.departmentDesc = clmPaytHdr.departmentDesc
          this.claimPayHeader.tranType1Desc = this.getDesc(this.getItemValue(clmPaytHdr.tranType1, this.tranTypeList1))
          this.claimPayHeader.cseStatDesc = this.getDesc(this.getItemValue(clmPaytHdr.cseStat, this.claimPayCseStatList))
          this.claimPayHeader.inOutGstDesc = this.getDesc(this.getItemValue(clmPaytHdr.inOutGst, this.gstIOs))
          this.claimPayHeader.currDesc = clmPaytHdr.currencyDesc
          this.claimPayHeader.prtClmPvDesc = this.getDesc(this.getItemValue(clmPaytHdr.prtClmPv, this.printDocOptsList))
          this.claimPayHeader.fundDesc = clmPaytHdr.fundDesc
          //
          // currency
          this.currList = dataMap.currList
          this.bankList = dataMap.activeBankList
          this.tranDateRange = dataMap.tranDateRange
          this.currRateList = dataMap.currRateList
          this.claimPayHeaderOrig = this.claimPayHeader
          if (dataMap.clmRiRcvy) {
            this.prevRcvyCurr = dataMap.clmRiRcvy.rcvyCurr
          }
        } else {
          this.$toast.error('Unexpected server response')
        }
      } else {
        this.$toast.error('Missing API URL (fetch claim release txn)')
      }
      this.loading = false
    },
    doCancel() {
      this.$router.push({ name: 'clmRel' })
    },
    async bankCurrChange() {
      this.$validator.validate('claimPayHeader.riRcvyCurr')
    },
    async process() {
      const apiUrl = this.menu.saveClaimReleaseTransaction
      if (apiUrl) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiUrl, this.claimPayHeader)
          if (result && result.data) {
            this.$router.push({ name: 'clmRel' })
          } else {
            this.$toast.error('Unexpected server response')
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('Missing API URL (fetch claim release txn)')
      }
      this.submitting = false
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.process()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    parseISO(value) {
      if (value) {
        return parseISO(value)
      } else {
        return undefined
      }
    },
    transDateChanged() {
      if (this.claimPayHeader.tranDate && Object.prototype.toString.call(this.claimPayHeader.tranDate) === '[object Date]') {
        const selectedDate = this.claimPayHeader.tranDate.setHours(0, 0, 0, 0)
        const dateToday = new Date().setHours(0, 0, 0, 0)
        if (selectedDate !== dateToday) {
          this.showTransDateNote = true
        }
      }
    },
    formatDisplayNumber(xNum, scale) {
      return formatDisplayNumber(xNum, scale)
    },
    getDesc(obj) {
      return obj.label !== undefined ? obj.label : ''
    },
    assignBaseCurr(data) {
      // this.baseCurrency = data[0]
    },
    checkUndefined(value, other) {
      if (typeof value === 'undefined') {
        return other
      }
      return value
    }
  },
  computed: {
    menu() {
      return this.$store.state.clmRel.menu
    },
    selected() {
      return this.$store.state.clmRel.sel
    },
    riRcvyCurrValidation() {
      return 'required' +
      // '|riRcvyCurr_70104:' + this.checkUndefined(this.param.bankTotalLocalCurr, '') + ',' + this.checkUndefined(this.claimPayHeader.curr, '') + ',' + this.checkUndefined(this.claimPayHeader.bankAcctCurr, '') +
      '|riRcvyCurr_70105:' + this.checkUndefined(this.claimPayHeader.curr, '') + ',' + this.checkUndefined(this.param.bankTotalLocalCurr, '')
      // '|riRcvyCurr_70106:' + this.checkUndefined(this.prevRcvyCurr, '')
    },
    chequeValidation() {
      let cheque = (this.claimPayHeader.bankChrgLoc !== 0 && this.claimPayHeader.tranType1 === 'Z')
      if (cheque) {
        return 'required' + '|cheque_70333:' + this.checkUndefined(this.claimPayHeader.bankNo, '')
      } else {
        return 'cheque_70333:' + this.checkUndefined(this.claimPayHeader.bankNo, '')
      }
    },
    bankChrgValidation() {
      return '|bankChrg_70224:' + this.checkUndefined(this.claimPayHeader.bankNo, '')
    },
    tranTypeSuffix() {
      if (this.claimPayHeader.tranType1 === 'Z' || this.claimPayHeader.tranType1 === 'Y') {
        return true
      }
      return false
    },
    tranTypeValidation() {
      if (this.claimPayHeader.tranType1 === 'Z' || this.claimPayHeader.tranType1 === 'Y') {
        return 'required'
      }
      return ''
    }
  },
  created() {
    this.doFetch()
    this.$validator.extend('tranDate_today', {
      getMessage(field, args) {
        return `The ${field} cannot be later than Today.`
      },
      validate(value, args) {
        if (value) {
          return !(isAfter(removeTime(value), removeTime(new Date())))
        } else return true
      }
    })
    this.$validator.extend('tranDate_rangeType', {
      getMessage(field, args) {
        return `Not in permitted Transaction Date Range Type 200. (70004).`
      },
      validate(value, args) {
        let effDate = args[0]
        let expDate = args[1]
        if (value) {
          return (isAfter(removeTime(value), removeTime(effDate)) || isEqual(removeTime(value), removeTime(effDate))) &&
          (isBefore(removeTime(value), removeTime(expDate)) || isEqual(removeTime(value), removeTime(expDate)))
        } else return true
      }
    })
    this.$validator.extend('riRcvyCurr_70105', {
      getMessage(field, args) {
        return `Must be Payment or Base Currency. (70105)`
      },
      validate(value, args) {
        let payment = args[0]
        let base = args[1]
        if (value) {
          return !(value !== base && value !== payment)
        } else return true
      }
    })
    this.$validator.extend('riRcvyCurr_70106', {
      getMessage(field, args) {
        return `Must be the same as previous recoveries on this transaction. (70106)`
      },
      validate(value, args) {
        let prevRcvyCurr = args[0]
        if (value) {
          return !(prevRcvyCurr !== '' && value !== prevRcvyCurr)
        } else return true
      }
    })
    this.$validator.extend('riRcvyCurr_70104', {
      getMessage(field, args) {
        return `Must be Base Currency if Bank Charges Currency not equal to Payment Currency. (70104)`
      },
      validate(value, args) {
        let base = args[0]
        let payment = args[1]
        let bankChrg = args[2]
        if (value) {
          return !(value !== base && bankChrg !== '' && bankChrg !== payment)
        } else return true
      }
    })
    // cheque
    this.$validator.extend('cheque_70333', {
      getMessage(field, args) {
        return `Please enter Bank No. first. (70333)`
      },
      validate(value, args) {
        let bankNo = args[0]
        if (value) {
          return ((value !== undefined && value !== '') && bankNo !== '')
        } else {
          return true
        }
      }
    })
    this.$validator.extend('bankChrg_70224', {
      getMessage(field, args) {
        return `Please enter Bank No or Bank Charge will be zerorised.`
      },
      validate(value, args) {
        let bankNo = args[0]
        let parseValue = parseFloat(value)
        if (!bankNo && parseValue !== 0) {
          return false
        } else return true
      }
    })
    // bankChrgLoc
    this.loading = false
  },
  watch: {
    'claimPayHeader.bankChrg': function() {
      let rate = this.getItemValue(this.claimPayHeader.bankAcctCurr, this.currRateList).secondaryValue
      let output = this.claimPayHeader.bankChrg * rate
      this.claimPayHeader.bankChrgLoc = isNaN(output) ? 0 : output
    },
    'claimPayHeader.bankAcctCurr': function() {
      let rate = this.getItemValue(this.claimPayHeader.bankAcctCurr, this.currRateList).secondaryValue
      let output = this.claimPayHeader.bankChrg * rate
      this.claimPayHeader.bankChrgLoc = isNaN(output) ? 0 : output
    },
    'claimPayHeader.bankNo': function(value) {
      let curr = this.getItemValue(value, this.bankList).secondaryValue
      this.claimPayHeader.bankAcctCurr = curr
    },
    'claimPayHeader.tranType1': function() {
      this.param.transactionType = this.claimPayHeader.tranType1
      this.getBaseCurr(this.param)
    }
  },

  mounted() {
  },
  mixins: [
    claimReleaseMixin,
    MessageMixin,
    commonAjaxMixin
  ]
}
</script>
